import { render, staticRenderFns } from "./paymentsledger.vue?vue&type=template&id=dad48398&"
import script from "./paymentsledger.vue?vue&type=script&lang=js&"
export * from "./paymentsledger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports